import { render, staticRenderFns } from "./properties-block-cards.vue?vue&type=template&id=2bb24fbd&scoped=true"
import script from "./properties-block-cards.vue?vue&type=script&lang=js"
export * from "./properties-block-cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb24fbd",
  null
  
)

export default component.exports